// src/endpoints.js
const API_BASE_URL = window._env_?.REACT_APP_GD_SYSHUB_BASE_URL;

const endpoints = {
    dateActivityInfoBanner: `${API_BASE_URL}/dateActivityInfo/banner`,
    dateActivityInfoInfo: `${API_BASE_URL}/dateActivityInfo/info`,
    dateSpeakerList: `${API_BASE_URL}/dateSpeaker/list`,
    dateAgendaList: `${API_BASE_URL}/dateAgenda/list`,
    dateSpecialReportList: `${API_BASE_URL}/dateSpecialReport/list`,
    dateSponsorList: `${API_BASE_URL}/dateSponsor/list`,
};

export default endpoints;
